import React from 'react'
import { useTranslation } from 'react-i18next';
import RouteOnSignin from './../../components/form/auth/route.on.signin'
import SvgLogo from "../../components/left-sidebar/logo-svg";
import {useAppSelector} from "../../redux/store";
import * as my from "../../components/form/field/MyForm";
import styled from "styled-components";
import {IconLogo} from "../../components/icons";

const LayoutBox = styled.div`
  background-color: var(--it-bg-dark-1);
  width: 100%;
  height: 100vh;
  overflow: hidden;
  
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  //TODO: check the media point transition
  @media all and (max-width: 1000px) {
    height: auto;
    min-height: 100vh;
  }
`

const LeftBox = styled.div`
  background-color: #000; //TODO: check the temp solution (video bg transition onResize) - what is about bottom ...?
  position: relative;
  width: 50%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; //TODO: check the temp solution (video bg transition onResize) for - what is about bottom ...?

  //TODO: check the media point transition
  @media all and (max-width: 1600px) {
    justify-content: flex-end; //TODO: check the temp solution (video bg transition onResize)
  }
  //TODO: check the media point transition
  @media all and (max-width: 1000px) {
    display: none;
    width: 100%;
  }
`

const RightBox = styled.div`
  position: relative;
  width: 50%;
  max-width: 520px;
  margin: 0 auto;
  padding: 1.5rem;
  height: 100vh;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  //TODO: check the media point transition
  @media all and (max-width: 1000px) {
    width: 100%;
  }
`

const HeaderBox = styled.div`
  width: 100%;
  margin-top: auto;
  margin-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  /*TODO: check the media point transition*/
  @media all and (max-width: 1000px) {
    margin-bottom: 2rem;
  }
`

const HeaderTitle = styled.div`
  width: 100%;
  color: var(--it-text-grey);
  text-align: center;

  /* Description */
  font-family: "Basis Grotesque Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 12px */
  letter-spacing: 0.36px;
  text-transform: uppercase;

  @media all and (max-width: 1000px) {
    font-size: 10px;
  }
`

const HeaderDescription = styled.div`
  width: 100%;
  color: var(--it-text-white);
  text-align: center;

  /* H1 */
  font-family: "Druk Wide";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 31.2px */
  letter-spacing: -0.72px;

  @media all and (max-width: 1000px) {
    font-size: 20px;
  }
`

const FooterBox = styled.div`
  width: 100%;
  margin-top: auto;
  padding-top: 1rem;
`

const FooterTitle = styled.div`
  width: 100%;
  color: var(--it-text-disabled);
  text-align: center;

  /* Body 2 */
  font-family: "Basis Grotesque Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
  letter-spacing: 0.24px;
`

const LogoIconTextBox = styled.div`
  z-index: 2;
  position: absolute;
  top: 5rem;
  left: 5rem;
  
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

const LogoIconBox = styled.div`
    
`

const LogoTextBox = styled.div`
    
`

const LogoText = styled.div`
  font-family: 'Druk Wide', sans-serif;
  text-wrap: nowrap;
  text-transform: uppercase;
  line-height: 120%;
  
  &[data-inv] {
    font-size: 14px;
  }
  &[data-app] {
    font-size: 10px;
  }
`

const LogoVideoBox = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const LogoVideoPreview = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  //filter: grayscale(50%);
`

const LogoVideo = ({className = ''}) => {
  return (
    <LogoVideoBox>
      <LogoVideoPreview
        autoPlay
        preload="auto"
        muted
        loop
        className={`${className}`}
      >
        <source src={'/video/logo-video-710x780.webm'} type="video/webm" media="(max-width: 1999px)" />
        <source src={'/video/logo-video-full.mp4'} type="video/mp4" media="(min-width: 2000px)" />
      </LogoVideoPreview>
    </LogoVideoBox>
  )
}

const LogoIconText = () => {
  return (
    <LogoIconTextBox>
      <LogoIconBox>
        <IconLogo size={22} fill="white" />
      </LogoIconBox>
      <LogoTextBox>
        <LogoText data-inv>Invisible</LogoText>
        <LogoText data-app>PWA</LogoText>
      </LogoTextBox>
    </LogoIconTextBox>
  )
}

const Layout = ({title, description, children}) => {
  const { t } = useTranslation();
  const {settings} = useAppSelector()

  return (
    <>
      <RouteOnSignin />

      <LayoutBox>
        <LeftBox>
          {/*<SvgLogo size={180} className={`mb-4`} />*/}
          {/*<span className={`text-2xl uppercase font-bold`}>{settings.project_name}</span>*/}
          <LogoIconText />
          <LogoVideo />
        </LeftBox>

        <RightBox>
          <HeaderBox>
            <HeaderTitle>{title}</HeaderTitle>
            <HeaderDescription>{description}</HeaderDescription>
          </HeaderBox>

          {children}

          <FooterBox>
            <FooterTitle>&copy; {settings.project_name}</FooterTitle>
          </FooterBox>
        </RightBox>
      </LayoutBox>
    </>
  )
}

export default Layout
